import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/apiClient";
import AdminLayout from "@/layouts/AdminLayout";
import { adminNav } from "@/lib/navConfig";
import { PageHeader } from "@/components/Common";
import { Input } from "@/components/ui/input";
import { ComplianceBadge } from "@/components/ComplianceBadge";
import { EmployeeDocs } from "@/components/EmployeeDocs";
import { ArrowLeft, Search, FileBadge } from "lucide-react";

export default function StaffCertificates() {
  const [emps, setEmps] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);
  const load = () => api.get("/employees").then((r) => setEmps((r.data || []).filter((e) => e.active !== false))).catch(() => {});
  useEffect(() => { load(); }, []);
  const list = useMemo(() => emps.filter((e) => `${e.first_name} ${e.surname} ${e.grade || ""}`.toLowerCase().includes(q.toLowerCase())), [emps, q]);
  const cur = emps.find((e) => e.id === sel);

  return (
    <AdminLayout nav={adminNav} title="Staff certificates">
      <Link to="/admin/compliance" data-testid="certs-back" className="inline-flex items-center gap-1 text-sm text-zinc-500 mb-2"><ArrowLeft className="h-4 w-4" />Compliance</Link>
      <PageHeader title="Staff certificates" subtitle="Pick a person to add, renew, upload or remove their certificates and documents" />
      <div className="grid md:grid-cols-[280px_1fr] gap-4">
        <div className="bg-white border border-zinc-200 rounded-md p-2 h-fit md:sticky md:top-4">
          <div className="relative mb-2"><Search className="h-4 w-4 absolute left-2.5 top-2.5 text-zinc-400" /><Input data-testid="certs-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search staff" className="pl-8 h-9" /></div>
          <div className="max-h-[60vh] overflow-y-auto space-y-0.5">
            {list.map((e) => (
              <button key={e.id} type="button" data-testid={`certs-emp-${e.id}`} onClick={() => setSel(e.id)}
                className={`w-full text-left px-2.5 py-2 rounded-md flex items-center justify-between gap-2 text-sm transition-colors ${sel === e.id ? "bg-slate-900 text-white" : "hover:bg-zinc-50"}`}>
                <span className="min-w-0"><span className="block font-medium truncate">{e.first_name} {e.surname}</span><span className={`block text-[11px] ${sel === e.id ? "text-zinc-300" : "text-zinc-400"}`}>{e.grade}</span></span>
                {e.compliance && <ComplianceBadge c={e.compliance} testId={`certs-comp-${e.id}`} />}
              </button>
            ))}
            {list.length === 0 && <div className="text-xs text-zinc-400 p-3">No staff match</div>}
          </div>
        </div>
        <div className="bg-white border border-zinc-200 rounded-md p-4 min-h-[300px]" data-testid="certs-panel">
          {cur ? (
            <>
              <div className="mb-3"><div className="font-heading font-bold text-lg text-slate-900" data-testid="certs-emp-name">{cur.first_name} {cur.surname}</div><div className="text-xs text-zinc-500">{cur.grade}</div></div>
              <EmployeeDocs key={cur.id} eid={cur.id} onChange={load} />
            </>
          ) : (
            <div className="h-full flex flex-col items-center justify-center text-zinc-400 text-sm py-16"><FileBadge className="h-8 w-8 mb-2" />Choose someone on the left</div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
